import { css } from '../../../styles/theme';

export const GlobalStyled = css``;
